import { STEP_NAME_KEYS } from '@/constants/'

const TOOLTIPS = {
    [STEP_NAME_KEYS.ISO_27001_SECURITY_OBJECTIVES]:
        'RESOURCE.OBJECTIVES_REQUIRED'
}

export { TOOLTIPS }
